import { render, staticRenderFns } from "./SleepManual.vue?vue&type=template&id=0801b37e"
import script from "./SleepManual.vue?vue&type=script&lang=js"
export * from "./SleepManual.vue?vue&type=script&lang=js"
import style0 from "./SleepManual.vue?vue&type=style&index=0&id=0801b37e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports